"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Preview = _interopRequireWildcard(require("../../pages/Gui/forms/Tables/Table/Preview"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _reactRedux = require("react-redux");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var Component = function Component(props) {
  var handle = props.handle,
    tableProps = props.tableProps;
  var appDefs = (0, _reactRedux.useSelector)(function (state) {
    return state.appdefs.appDefsObject;
  });
  var settings = ((0, _get2["default"])(appDefs, 'customTables.list') || []).find(function (item) {
    return item.id === handle;
  });
  if (!settings) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "alert alert-danger"
    }, "There is no table with id=".concat(handle));
  }
  var query = (0, _Preview.getQuery)(settings);
  return /*#__PURE__*/_react["default"].createElement(_Preview["default"], {
    query: query,
    settings: settings,
    tableProps: tableProps
  });
};
Component.propTypes = {
  handle: _propTypes["default"].string.isRequired,
  tableProps: _propTypes["default"].object
};
var _default = exports["default"] = Component;